module.exports = __webpack_public_path__ + "img/s00172.c4316dc6.png";